import { formatDateOnlyString, isValidDateInstance } from '../../../../../../../utils';

export const VALIDITY_RANGE_ORDERING_ERROR_KEYS = {
  validNoticeFrom: 'userDetail.employeeDocumentation.expiration.error.softBeforeValidFrom',
  validThrough: 'userDetail.employeeDocumentation.expiration.error.hardBeforeSoft',
};

export const getValidityRangeOrderingErrorKeys = ({ validFrom, validNoticeFrom, validThrough }) => {
  const validFromDate = formatDateOnlyString(validFrom);
  const validNoticeFromDate = formatDateOnlyString(validNoticeFrom);
  const validThroughDate = formatDateOnlyString(validThrough);
  const errors = {};

  if (validFromDate && validNoticeFromDate && validFromDate > validNoticeFromDate) {
    errors.validNoticeFrom = VALIDITY_RANGE_ORDERING_ERROR_KEYS.validNoticeFrom;
  }

  if (validNoticeFromDate && validThroughDate && validNoticeFromDate > validThroughDate) {
    errors.validThrough = VALIDITY_RANGE_ORDERING_ERROR_KEYS.validThrough;
  }

  return errors;
};

export const isExpirationSaveDisabled = ({
  validFrom,
  validNoticeFrom,
  validThrough,
  isSaving,
}) => {
  if (isSaving) return true;
  if (![validFrom, validNoticeFrom, validThrough].every(isValidDateInstance)) return true;

  return (
    Object.keys(getValidityRangeOrderingErrorKeys({ validFrom, validNoticeFrom, validThrough }))
      .length > 0
  );
};
